__turbopack_context__.v({
  "btn": "footer-module-scss-module__BKh3Zq__btn",
  "btn-alt": "footer-module-scss-module__BKh3Zq__btn-alt",
  "btn-default": "footer-module-scss-module__BKh3Zq__btn-default",
  "btn-default-dark-bg": "footer-module-scss-module__BKh3Zq__btn-default-dark-bg",
  "btn-disabled": "footer-module-scss-module__BKh3Zq__btn-disabled",
  "btn-elite": "footer-module-scss-module__BKh3Zq__btn-elite",
  "btn-gold": "footer-module-scss-module__BKh3Zq__btn-gold",
  "btn-lg": "footer-module-scss-module__BKh3Zq__btn-lg",
  "btn-link": "footer-module-scss-module__BKh3Zq__btn-link",
  "btn-plat": "footer-module-scss-module__BKh3Zq__btn-plat",
  "btn-primary": "footer-module-scss-module__BKh3Zq__btn-primary",
  "btn-sm": "footer-module-scss-module__BKh3Zq__btn-sm",
  "btn-success": "footer-module-scss-module__BKh3Zq__btn-success",
  "btn-warning": "footer-module-scss-module__BKh3Zq__btn-warning",
  "container": "footer-module-scss-module__BKh3Zq__container",
  "copyRights": "footer-module-scss-module__BKh3Zq__copyRights",
  "csDivider": "footer-module-scss-module__BKh3Zq__csDivider",
  "csFooter": "footer-module-scss-module__BKh3Zq__csFooter",
  "disabled": "footer-module-scss-module__BKh3Zq__disabled",
  "footer": "footer-module-scss-module__BKh3Zq__footer",
  "logoAndPhone": "footer-module-scss-module__BKh3Zq__logoAndPhone",
  "mobile": "footer-module-scss-module__BKh3Zq__mobile",
  "spacerForStickyBottomButton": "footer-module-scss-module__BKh3Zq__spacerForStickyBottomButton",
  "tablet": "footer-module-scss-module__BKh3Zq__tablet",
  "terms": "footer-module-scss-module__BKh3Zq__terms",
});
